export default __webpack_public_path__ + "static/media/right.74a5323e.svg";